<template>
  <div class="gs-app gm-mail-lists-refresh gm-refresh-tables flex mb-4 mx-4">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading" style="z-index: 99;">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>

    <div class="w-full relative gm-mail-lists-refresh__workspace">
      <navigation-tabs
        class="gm-nav-list-tabs absolute"
        :nav_tabs="navTabs"
      ></navigation-tabs>
      <server-table :key="tabelKey"
        class="text-center groovemail-list-table gs-refresh-controls"
        :url="mailListUrl"
        ref="serverTableList"
        tableRef="listsTable"
        :slotData="listTableSlotData"
        :tableColumns="mailListsTableColumns"
        :tableOptions="mailListsTableOptions"
        :emptyStateData="emptyStateData"
        tableTitle="frontend_builder_lists"
        addNewBtnText="frontend_groovemail_mail_list_newlist"
        @addNewData="openCreateMaillist"
        @loading="showLoader()"
        @loaded="hideLoader()"
      >
      </server-table>
      <gs-named-modal
        name="maillist-modal"
        :title="
          modalType === 'add'
            ? $t('frontend_groovemail_contacts_step4_create_new_list')
            : $t('frontend_groovemail_lists_edit_list')
        "
      >
        <div class="gs-app gm-mail-lists-refresh__dialog gm-refresh-dialog">
          <create-list
            :type="modalType"
            :mail_list_id="mailListId"
            :mail_list_data="mailList"
            @fetchEventsList="fetchEventsList(modalType === 'add' ? 1 : null)"
            @closeCreateMaillistModal="closeMailListModal"
            @closeEditMaillistModal="closeMailListModal"
            @showLoader="showLoader"
            @hideLoader="hideLoader"
          >
          </create-list>
        </div>
      </gs-named-modal>
    </div>

    <!-- Confirmation delete modal -->
    <confirm-modal
      :ref="`confirmation-delete-mail-list`"
      :name="`confirmation-delete-mail-list`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_swal_revert_message')"
      @confirm="deleteMailList"
      @close="closeDeleteListModal"
    />
  </div>
</template>

<script>
import axios from 'axios';
import Notify from '@groovepages/gd-ui-kit/notify';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import { isKeyTimedOut } from '@/utils/localStorageHelper';
import CreateList from '@/components/create-lists.vue';
import monthsMixin from '@/mixin/monthsMixin.js';
import { listUrls } from '@/utils/urls.js';
import { refreshMailObject } from '@/utils/refreshHelper';
import { getData, deleteData } from '@/utils/apiHelper.js';
import NavigationTabs from '@/components/navigation-tabs.vue';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

import themeConfig from '@/theme/themeConfig.js';
import showAlert from '@/components/sweet-alert-popup.js';

let self;

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('frontend_groovemail_sequences_lists') };
  },
  mixins: [monthsMixin, demoModeValuesMixin],
  data() {
    return {
      tabelKey: 0,
      totalLists: 0,
      modalType: 'add',
      leadsType: 0,
      isLoading: false,
      mailListId: null,
      mailListUrl: listUrls.list,
      mailList: { name: '', description: '' },
      leadsUrl: '',
      leadsColumns: ['first_name', 'last_name', 'email'],
      leadsDataOptions: {
        perPage: 5,
        debounce: 1000,
        perPageValues: [5],
        pagination: { chunk: 5 },
        requestFunction(data) {
          self = this;
          const customUrl = self.url.split('?');
          const listId = customUrl[1].split('=')[1];
          return axios
            .post(
              customUrl[0],
              { list_id: listId },
              {
                params: data,
              }
            )
            .catch((e) => {
              self.dispatch('error', e);
              this.hideLoader();
            });
        },
        responseAdapter({ data }) {
          if (self.demoMode) {
            const newData = data?.data.map((obj) => ({
              ...obj,
              email: self.basicEmailText,
              first_name: self.basicText,
              last_name: self.basicText,
            }));
            return {
              data: newData,
              count: newData.length,
            };
          }
          return {
            data: data.data,
            count: data.total,
          };
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        sortable: [],
        filterable: [],
        headings: {
          first_name: () => this.$t('frontend_resource_promo_first_name'),
          last_name: () => this.$t('frontend_resource_promo_last_name'),
          email: () => this.$t('frontend_resource_promo_email'),
        },
        rowClassCallback: () => 'hover:bg-grey-50 funnelRow',
      },
      navTabs: [
        {
          tabName: 'frontend_groovemail_components_pricepoint_sidebar_lists',
          tabRoute: 'Lists',
        },
        {
          tabName: 'frontend_groovemail_components_pricepoint_sidebar_tags',
          tabRoute: 'Tags',
        },
        {
          tabName: 'frontend_sites_template_categories',
          tabRoute: 'list',
        },
        {
          tabName: 'frontend_groovemail_components_pricepoint_sidebar_segments',
          tabRoute: 'Segments',
        },
      ],
      mailListsTableColumns: [
        'refresh',
        'name',
        'id',
        'subscribe_leads_count',
        'unsubscribe_leads_count',
        'activeleads_count',
        'created_at',
        'actions',
      ],
      mailListsTableOptions: {
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        sortable: [
          'name',
          'created_at',
          'activeleads_count',
          'subscribe_leads_count',
          'unsubscribe_leads_count',
        ],
        headings: {
          refresh: () => '',
          id: () => this.$t('frontend_groovemail_mail_lists_list_id'),
          name: () => this.$t('frontend_groovemail_adminsetting_name'),
          activeleads_count: () =>
            this.$t('frontend_groovemail_components_checkout_total'),
          subscribe_leads_count: () =>
            this.$t('frontend_groovemail_segment_subscribe_emails'),
          unsubscribe_leads_count: () =>
            this.$t(
              'frontend_groovemail_lead_listing_advanced_filters_status_unsubscribed'
            ),
          created_at: () => this.$t('frontend_groovemail_created_at'),
          actions: () => this.$t('frontend_groovemail_mail_lead_actions'),
        },
        filterable: ['name'],
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        rowClassCallback: () => 'hover:bg-grey-50 funnelRow',
        pagination: { chunk: 5 },
        requestFunction(data) {
          self = this;
          const requestParams = { ...data };
          if (!(requestParams && requestParams.orderBy)) {
            requestParams.orderBy = 'created_at';
            requestParams.ascending = 0;
          }
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
          const mailListTableData = data?.data.map((row) => {
            return {
              ...row,
              disabled: isKeyTimedOut('mailList', row.id),
            };
          });
          self.totalLists = data.total;
          return {
            data: mailListTableData,
            count: data.total,
          };
        },
      },
      emptyStateData: {
        emptyStateHeading: 'frontend_builder_lists',
        emptyStateSubHeading: 'frontend_groovemail_lists_have_no_data',
        emptyStateBtnText: 'frontend_groovemail_mail_list_newlist',
      },
    };
  },

  components: {
    CreateList,
    NavigationTabs,
    ServerTable,
  },

  computed: {
    /**
     * Returns title for view-leads-modal based on leadsType.
     * if leadType = 1, Active Contacts
     *    leadType = 2, Unsubscribed Contacts
     * @return {string} title of view-leads-modal.
     */
    leadsTitle() {
      return this.leadsType === 1
        ? `${this.$t('frontend_groovemail_segment_subscribe_emails')} ${this.$t(
            'frontend_groovemail_leads_route_page_title'
          )}`
        : `${this.$t(
            'frontend_groovemail_lead_listing_advanced_filters_status_unsubscribed'
          )} ${this.$t('frontend_groovemail_leads_route_page_title')}`;
    },

    /**
     * Returns slot data for list table.
     * @return {array} details for slot columns for list table.
    */
    listTableSlotData() {
      return [
        {
          slotName: 'refresh',
          slotType: 'default',
          conditions: () => true,
          callback: (props) => {
            if (!props.row.disabled) {
              this.refreshMailList(props.row.id);
            }
            return null;
          },
          html: (props) => {
            const tooltipText = props.row.disabled
              ? this.$t('frontend_groovemail_disabled_refresh_button_tooltip')
              : this.$t('frontend_groovemail_refresh_button');

            const iconClass = props.row.disabled
              ? 'h-5 w-5 mt-1 refresh-icon-disabled'
              : 'h-5 w-5 mt-1 refresh-icon text-primary';

            const iconId = props.row.id ? `id="refreshIcon-${props.row.id}"` : '';

            const refreshIcon = `
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="${iconClass}" ${iconId}>
                <path fill="currentcolor" d="M12,2a10.032,10.032,0,0,1,7.122,3H16a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1h4.143A1.858,1.858,0,0,0,22,5.143V1a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1V3.078A11.981,11.981,0,0,0,.05,10.9a1.007,1.007,0,0,0,1,1.1h0a.982.982,0,0,0,.989-.878A10.014,10.014,0,0,1,12,2Z"/>
                <path fill="currentcolor" d="M22.951,12a.982.982,0,0,0-.989.878A9.986,9.986,0,0,1,4.878,19H8a1,1,0,0,0,1-1H9a1,1,0,0,0-1-1H3.857A1.856,1.856,0,0,0,2,18.857V23a1,1,0,0,0,1,1H3a1,1,0,0,0,1-1V20.922A11.981,11.981,0,0,0,23.95,13.1a1.007,1.007,0,0,0-1-1.1Z"/>
              </svg>
            `;

            return `
              <span class="tooltip-refresh-btn">
                ${refreshIcon}
                <span class="tooltiptext">${tooltipText}</span>
              </span>
            `;
          },
        },
        {
          slotName: 'id',
          slotType: 'copy',
          value: (props) => props.row.id,
          tooltip: {
            content: this.$t('frontend_resource_index_copy_to_clipboard'),
            placement: 'top',
            classes: ['info'],
            targetClasses: ['it-has-a-tooltip'],
            offset: 10,
            delay: {
              show: 200,
              hide: 300,
            },
          },
          onCopyEmbedCode: () => this.onCopyEmbedCode(),
          onErrorEmbedCode: () => this.onErrorEmbedCode(),
        },
        {
          slotName: 'name',
          slotType: 'computed',
          classes: () => '',
          value: (props) => {
            return props.row.name
              ? props.row.name
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'subscribe_leads_count',
          slotType: 'clickable',
          classes: () => '',
          callback: (props) => this.gotToFilterActiveLeads(props.row),
          defaultValue: 0,
        },
        {
          slotName: 'activeleads_count',
          slotType: 'clickable',
          classes: () => '',
          callback: (props) => this.goToFilteredLeads(props.row),
          defaultValue: 0,
        },
        {
          slotName: 'unsubscribe_leads_count',
          slotType: 'clickable',
          classes: () => '',
          callback: (props) => this.goToUnsubscribedLeads(props.row),
          defaultValue: 0,
        },
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => '',
          value: (props) =>
            props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available'),
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => true,
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_edit'),
              conditions: (row) => row.is_default !== 1,
              callback: (props) => this.openEditMaillist(props.row.id),
            },
            {
              id: 1,
              name: () => this.$t('frontend_groovemail_lists_export_contacts'),
              conditions: (row) => row.activeleads_count,
              callback: (props) => this.exportContacts(props.row.id),
            },
            {
              id: 2,
              name: () => this.$t('frontend_delete'),
              conditions: (row) => !(row.activeleads_count || row.is_default === 1),
              callback: (props) => this.openDeleteListModal(props.row.id),
            },
          ],
        },
      ];
    },

    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },
  },

  methods: {
    // shows loader when lists table is loading
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    // hides loader when lists table finishes loading
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    // Shows success notification when list Id is copied successfully
    onCopyEmbedCode() {
      Notify.success(
        this.$t('frontend_groovemail_mail_lists_list_id_copy_success')
      );
    },

    // Shows error notification when list Id is not copied successfully
    onErrorEmbedCode() {
      Notify.fail(
        this.$t('frontend_groovemail_mail_lists_list_id_copy_failure')
      );
    },

    /**
     * Redirects to Contacts page that displays details of all contacts present in that List.
     * Filter is applied to display only Active contacts present in that list.
     * @param {object} list - contains detail of the list.
    */
    async gotToFilterActiveLeads(list) {
      this.$router.push({
        name: 'Leads2',
        query: { listId: list.id, listName: list.name, statusId: 3, statusName: 'Verified'},
      });
    },

    /**
     * Redirects to Contacts page that displays details of all contacts present in that List.
     * Filter is applied to display only Unsubscribed contacts present in that list.
     * @param {string} listId unique id of list.
     */
    async goToUnsubscribedLeads(list) {
      this.$router.push({
        name: 'Leads2',
        query: { listId: list.id, listName: list.name, statusId: 2, statusName: 'Unsubscribed' },
      });
    },

    /**
     * Redirects to Contacts page that displays details of all contacts present in that List.
     * @param {object} list - contains detail of the list.
     */
    async goToFilteredLeads(list) {
      this.$router.push({
        name: 'Leads2',
        query: { listId: list.id, listName: list.name },
      });
    },

    /**
     * Used to download all contacts present in the list in .csv format.
     * @param {string} listId unique id of a list.
     */
    async exportContacts(listId) {
      const paramsData = {
        exportContact: listId,
      };

      try {
        const response = await getData(listUrls.list, { params: paramsData });
        if (response) {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'contacts.csv');
          document.body.appendChild(fileLink);
          fileLink.click();
        }

      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    // Opens create-maillist-modal to add list.
    openCreateMaillist() {
      this.modalType = 'add';
      this.mailList.name = '';
      this.mailList.description = '';
      this.openMailListModal();
    },

    // Opens create/edit-maillist-modal.
    openMailListModal() {
      this.$root.$emit('modal-open', 'maillist-modal');
    },

    // Closes create/edit-maillist-modal.
    closeMailListModal() {
      this.$root.$emit('modal-close', 'maillist-modal');
    },

    /**
     * Opens edit maillist modal list
     * @param {string} id unique id of a list.
     */
    async openEditMaillist(id) {
      this.modalType = 'edit';
      this.mailListId = id;

      try {
        const response = await getData(`${listUrls.list}/${id}`);
        if (response) {
          this.mailList.name = response?.data?.data?.name;
          this.mailList.description = response?.data?.data?.description;
        }
        this.openMailListModal();

      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    /**
     * Fetches the list based on queries passed.
     * @param {string} pageNo page number of list table.
     */
    async fetchEventsList(pageNo) {
      // show loader
      this.showLoader();

      // if table is not available, then refresh the table.
      if (!this.$refs.serverTableList.$refs.listsTable) {
        // this is to refresh the table when the list is updated.
        this.tabelKey += 1;

        // hide loader
        this.hideLoader();
        return;
      }

      const paramsData = {
        query: this.$refs?.serverTableList?.$refs?.listsTable?.filteredQuery,
        limit: this.mailListsTableOptions.perPage,
        page: pageNo
          ? pageNo
          : this.$refs.serverTableList.$refs.listsTable.Page,
        ascending: 0,
        byColumn: 0,
      };

      try {
        const listData = await getData(listUrls.list, { params: paramsData });
        this.totalLists = listData?.data?.total;
        this.$refs.serverTableList.updateData(
          listData?.data?.data,
          listData?.data?.total
        );

        // hide loader
        this.hideLoader();
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error);
      }
    },


    // open delete list modal
    async openDeleteListModal(id) {
      // set the list id
      this.mailListId = id;

      // open the modal
      this.$refs[`confirmation-delete-mail-list`].open();
    },

    // close delete list modal
    closeDeleteListModal() {
      // reset the list id
      this.mailListId = null;

      // close the modal
      this.$refs[`confirmation-delete-mail-list`].close();
    },

    // delete mail list
    async deleteMailList() {
      try {
        await deleteData(`${listUrls.list}/${this.mailListId}`);
        await this.fetchEventsList();

        // check if the table data = 1
        if (this.$refs.serverTableList.$refs.listsTable.data.length < 1) {
          this.tabelKey += 1;
        }

      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);
      }
    },

    getRowIndex(listData, id) {
      return listData.findIndex((element) => element.id === id);
    },

    updateRowData(id, data) {
      const mailListData = this.$refs.serverTableList.$refs.listsTable?.data;
      const rowIndex = this.getRowIndex(mailListData, id);
      mailListData[rowIndex] = {
        id,
        ...data,
        disabled: true,
      };
      
      this.$refs.serverTableList.updateData(mailListData, this.totalLists);
    },

    async refreshMailList(id) {
      try {
        const url = `${listUrls.listRefresh}/${id}`;
        const response = await refreshMailObject(id, url, 'mailList');
        if (response) {
          this.updateRowData(id, response);
        }
      } catch (error) {
        this.requestErrorAlert(error.response?.data?.error);
      }
    },
  },

  created() {
    self = this;
  },

  mounted() {
    // adding the logic to get rows from table and applying hover event listener on them
    const rows = document.querySelectorAll('.VueTables__table.bg-white.text-center.rounded tbody');

    rows.forEach((row) => {
      row.addEventListener('mouseover', () => {
        this.mouseHoveredOnTable = true;
      });
      row.addEventListener('mouseout', () => {
        this.mouseHoveredOnTable = false;
      });
    });
  },
};
</script>

<style lang="scss">
.groovemail-list-table {
  .refresh-icon-disabled {
    cursor: pointer;
    color: var(--gs-border-strong);
  }
  .tooltip-refresh-btn {
    position: relative;
    display: inline-block;
    
    .tooltiptext {
      visibility: hidden;
      width: 120px;
      background-color: var(--gs-surface);
      color: var(--gs-foreground);
      text-align: center;
      border: 1px solid var(--gs-border);
      border-radius: var(--gs-radius-sm);
      box-shadow: var(--gs-shadow-md);
      font-size: 12px;
      font-weight: 600;
      padding: 5px 0;
      /* Position the tooltip */
      position: absolute;
      z-index: 1;
      top: 30px;
      left: -50px;
    }
    
    &:hover .tooltiptext {
      visibility: visible;
    }
  }

  .refresh-icon {
    cursor: pointer;
    color: var(--gs-muted-foreground);
    transition: transform 0.5s ease-in-out, color 120ms ease;

    &:hover {
      color: var(--gs-primary);
    }
    
    &.spin {
      animation: spin 0.5s infinite linear;
    }
  }


  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .VueTables--server table {
    overflow: auto !important;
    th:nth-child(2),
    td:nth-child(2),
    th:nth-child(3),
    td:nth-child(3) {
      width: 20%;
    }
    td:nth-child(4),
    th:nth-child(4),
    td:nth-child(5),
    th:nth-child(5),
    th:nth-child(6),
    td:nth-child(6),
    th:nth-child(7),
    td:nth-child(7) {
      width: 12%;
    }
    th:last-child span {
      display: none;
    }
  }
}

.gm-nav-list-tabs {
  top: 25px;
  z-index: 10;
}
</style>

<style scoped>
.gm-mail-lists-refresh {
  min-height: 100%;
  padding: 28px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gm-mail-lists-refresh__workspace {
  min-width: 0;
  padding: 20px 24px 24px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

.gm-mail-lists-refresh >>> .table-responsive {
  max-width: 100%;
  overflow-x: auto;
}

@media (max-width: 640px) {
  .gm-mail-lists-refresh {
    padding: 18px 12px 32px;
    margin-inline: 0;
  }

  .gm-mail-lists-refresh__workspace {
    padding: 16px;
  }
}
</style>
